
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uxcore",
      function () {
        return require("private-next-pages/uxcore/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uxcore"])
      });
    }
  